import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CementoParametroDto } from '../../../../models/parametro-cemento.dto';

@Component({
  selector: 'app-parametro-cemento-edit-modal',
  templateUrl: './parametro-cemento-edit-modal.component.html',
})
export class ParametroCementoEditModalComponent implements OnInit {
  private readonly activeModal = inject(NgbActiveModal);
  private readonly fb = inject(FormBuilder);

  @Input() param!: CementoParametroDto;

  form!: FormGroup;

  ngOnInit() {
    this.form = this.fb.group({
      name: [{ value: this.param.name, disabled: true }],
      value: [this.param.value, [Validators.required]],
      description: [this.param.description],
    });
  }

  close() {
    this.activeModal.dismiss();
  }

  save() {
    if (this.form.invalid) return;
    this.activeModal.close(this.form.value);
  }
}
